import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rx-applications-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  completion = input<number>(0);
  testIdPrefix = input<string>('test-progress-bar');
  //Ranges the completion to 0 to 100
  completionBarSize = computed(() => {
    return Math.max(Math.min(Math.floor(this.completion()), 100), 0);
  });

}
